/**
 * Strategy gate utility.
 *
 * Certain pages require the user to have at least one strategy.
 * This pure helper determines whether a redirect to the Backtesting page
 * is needed, given the current page, strategy availability, and loading state.
 */

import type { ActivePage } from '../stores/paperTradingStore';

/** Pages that require at least one strategy to access. */
const GATED_PAGES = new Set<ActivePage>(['optimizations', 'configurations', 'portfolios', 'paper-trading']);

/**
 * Returns true when the user should be redirected away from the given page
 * because they have no strategies.
 *
 * - Returns false while loading (avoids flash redirect on initial mount).
 * - Returns false when the user has strategies.
 * - Returns false for non-gated pages.
 */
export function shouldRedirectFromGatedPage(
  page: ActivePage,
  hasStrategies: boolean,
  isLoading: boolean,
): boolean {
  if (isLoading) return false;
  if (hasStrategies) return false;
  return GATED_PAGES.has(page);
}
